const mapBoxSettings = {

    accessToken: "pk.eyJ1Ijoicmlja2FyZDg5IiwiYSI6ImNsbHo2cmlzdTBudTQzZG4xeWUxbnlsazYifQ.1U9zona99cqOO9RLmFufFA",

    mapStyle: {
        version: 8,
        name: "Mapbox Satellite",
        metadata: {
            "mapbox:type": "default",
            "mapbox:origin": "satellite-streets-v12",
            "mapbox:sdk-support": {
                "js": "3.0.0",
                "android": "11.0.0",
                "ios": "11.0.0"
            },
            "mapbox:autocomposite": true,
            "mapbox:groups": {
                "Transit, transit-labels": {
                    "name": "Transit, transit-labels",
                    "collapsed": true
                },
                "Administrative boundaries, admin": {
                    "name": "Administrative boundaries, admin",
                    "collapsed": true
                },
                "Transit, bridges": { "name": "Transit, bridges", "collapsed": true },
                "Road network, bridges": {
                    "name": "Road network, bridges",
                    "collapsed": true
                },
                "Road network, tunnels": {
                    "name": "Road network, tunnels",
                    "collapsed": true
                },
                "Road network, road-labels": {
                    "name": "Road network, road-labels",
                    "collapsed": true
                },
                "Natural features, natural-labels": {
                    "name": "Natural features, natural-labels",
                    "collapsed": true
                },
                "Road network, surface": {
                    "name": "Road network, surface",
                    "collapsed": true
                },
                "Walking, cycling, etc., barriers-bridges": {
                    "name": "Walking, cycling, etc., barriers-bridges",
                    "collapsed": true
                },
                "Place labels, place-labels": {
                    "name": "Place labels, place-labels",
                    "collapsed": true
                },
                "Point of interest labels, poi-labels": {
                    "name": "Point of interest labels, poi-labels",
                    "collapsed": true
                },
                "Walking, cycling, etc., tunnels": {
                    "name": "Walking, cycling, etc., tunnels",
                    "collapsed": true
                },
                "Walking, cycling, etc., walking-cycling-labels": {
                    "name": "Walking, cycling, etc., walking-cycling-labels",
                    "collapsed": true
                },
                "Walking, cycling, etc., surface": {
                    "name": "Walking, cycling, etc., surface",
                    "collapsed": true
                },
                "Satellite imagery, land": {
                    "name": "Satellite imagery, land",
                    "collapsed": true
                },
                "Transit, ferry-aerialway-labels": {
                    "name": "Transit, ferry-aerialway-labels",
                    "collapsed": true
                }
            },
            "mapbox:decompiler": {
                "id": "cllz8h5sr00nl01nz3me5bi46",
                "componentVersion": "18.0.0",
                "strata": [
                    {
                        "id": "satellite-streets-v12",
                        "order": [
                            ["transit", "built"],
                            ["satellite", "land"],
                            ["walking-cycling", "tunnels"],
                            ["road-network", "tunnels"],
                            ["walking-cycling", "surface"],
                            ["road-network", "surface"],
                            ["transit", "surface"],
                            ["walking-cycling", "barriers-bridges"],
                            ["road-network", "bridges"],
                            ["transit", "bridges"],
                            ["admin-boundaries", "admin"],
                            ["road-network", "road-labels"],
                            ["walking-cycling", "walking-cycling-labels"],
                            ["transit", "ferry-aerialway-labels"],
                            ["natural-features", "natural-labels"],
                            ["point-of-interest-labels", "poi-labels"],
                            ["transit", "transit-labels"],
                            ["place-labels", "place-labels"]
                        ]
                    }
                ],
                "components": {
                    "satellite": "18.0.0",
                    "road-network": "18.0.0",
                    "walking-cycling": "18.0.0",
                    "admin-boundaries": "18.0.0",
                    "natural-features": "18.0.0",
                    "point-of-interest-labels": "18.0.0",
                    "transit": "18.0.0",
                    "place-labels": "18.0.0"
                },
                "propConfig": {
                    "satellite": {},
                    "road-network": {
                        "roadsFont": ["DIN Pro Medium", "Arial Unicode MS Regular"],
                        "colorRoad": "hsla(0, 0%, 80%, 0.8)",
                        "iconSaturation": -0.5,
                        "construction": false,
                        "colorRoadLabel": "hsl(0, 0%, 100%)",
                        "fadeOutRoadsOnZoom": true,
                        "colorBase": "hsl(0, 0%, 0%)",
                        "roadsSize": 1.1,
                        "colorMotorwayTrunk": "hsla(40, 90%, 70%, 0.8)",
                        "polygonFeatures": false,
                        "colorPathOutline": "hsla(40, 95%, 90%, 0.8)",
                        "roadMarkings": false,
                        "turningCircles": false,
                        "colorRoadOutline": "hsla(0, 1%, 10%, 0.7)"
                    },
                    "walking-cycling": {
                        "roadsFont": ["DIN Pro Medium", "Arial Unicode MS Regular"],
                        "colorRoad": "hsla(0, 0%, 80%, 0.8)",
                        "golfHoleLabelLine": false,
                        "colorGreenspace": "hsl(94, 100%, 14%)",
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "colorPoiParkLike": "hsl(110, 100%, 80%)",
                        "fadeOutPathsOnZoom": true,
                        "walkingCyclingPisteBackground": false,
                        "colorRoadLabel": "hsl(0, 0%, 100%)",
                        "colorBase": "hsl(0, 0%, 0%)",
                        "roadsSize": 1.1,
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorPathOutline": "hsla(40, 95%, 90%, 0.8)",
                        "pedestrianPolygonFeatures": false,
                        "colorRoadOutline": "hsla(0, 1%, 10%, 0.7)",
                        "labels": true
                    },
                    "admin-boundaries": {
                        "admin0Width": 1.5,
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorAdminBoundary": "hsl(260, 15%, 80%)",
                        "admin0DashPattern": "Dash on zoom"
                    },
                    "natural-features": {
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorWater": "hsl(240, 100%, 62%)",
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "labelHalo": true,
                        "poiIconScale": 0.8
                    },
                    "point-of-interest-labels": {
                        "poiIconBackground": "Circle",
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "colorPoiParkLike": "hsl(110, 100%, 80%)",
                        "colorPoiMedical": "hsl(360, 100%, 80%)",
                        "colorPoiEducation": "hsl(30, 100%, 80%)",
                        "poiIconScale": 0.8
                    },
                    "transit": {
                        "matchLabelAndIcon": false,
                        "roadsFont": ["DIN Pro Medium", "Arial Unicode MS Regular"],
                        "aeroways": false,
                        "poiIconScale": 0.8,
                        "colorPoi": "hsl(0, 0%, 100%)",
                        "colorAirport": "hsl(0, 0%, 100%)",
                        "colorTransit": "hsl(204, 100%, 80%)",
                        "poiIconBackground": "Rectangle",
                        "colorBase": "hsl(0, 0%, 0%)",
                        "colorWater": "hsl(240, 100%, 62%)",
                        "roadsSize": 1.1,
                        "railways": false,
                        "ferries": false,
                        "poiEtcFont": ["DIN Pro Bold", "Arial Unicode MS Bold"],
                        "colorRoadOutline": "hsla(0, 1%, 10%, 0.7)"
                    },
                    "place-labels": {
                        "continentsSize": 1.1,
                        "statesSize": 1.1,
                        "settlements": true,
                        "settlementsMinorSize": 1.1,
                        "settlementsMajorSize": 1.1,
                        "colorPlaceLabel": "hsl(0, 0%, 100%)",
                        "settlementSubdivisionsSize": 1.1,
                        "colorBase": "hsl(0, 0%, 0%)",
                        "countries": true,
                        "countriesSize": 1.1,
                        "language": "Local",
                        "settlementsMinorFont": [
                            "DIN Pro Medium",
                            "Arial Unicode MS Regular"
                        ],
                        "settlementsDensity": 3,
                        "settlementSubdivisionsFont": [
                            "DIN Pro Medium",
                            "Arial Unicode MS Regular"
                        ],
                        "continents": true
                    }
                }
            },
            "mapbox:uiParadigm": "global"
        },

        sources: {
            "mapbox": {
                "url": "mapbox://mapbox.satellite",
                "type": "raster",
                "tileSize": 256
            },
            "mapbox-dem": {
                "url": "mapbox://mapbox.mapbox-terrain-dem-v1",
                "type": "raster-dem",
                "tileSize": 512
            },
            "composite": {
                "url": "mapbox://mapbox.mapbox-streets-v8",
                "type": "vector"
            }
        },

        center: [13.196228297526488, 55.702122109550686],

        zoom: 17.02298616882512,

        bearing: 0,
        pitch: 0,
        terrain: { "source": "mapbox-dem" },

        fog: {
            "range": [1, 10],
            "color": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                "hsl(240, 12%, 70%)",
                6,
                "hsl(0, 0%, 100%)"
            ],
            "high-color": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                "hsl(240, 12%, 7%)",
                6,
                "hsl(38, 63%, 84%)"
            ],
            "space-color": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                "hsl(240, 12%, 9%)",
                6,
                "hsl(199, 61%, 80%)"
            ],
            "horizon-blend": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                0.008,
                6,
                0.15
            ],
            "star-intensity": [
                "interpolate",
                ["exponential", 1.2],
                ["zoom"],
                5.5,
                0.1,
                6,
                0
            ]
        },

        sprite: "mapbox://sprites/rickard89/cllz8h5sr00nl01nz3me5bi46/eo3vup4jd1srns5ao3qj8hkpm",
        glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",

        projection: { "name": "globe" },

        created: "2023-08-31T14:00:28.827Z",
        modified: "2023-08-31T14:04:54.252Z",
        id: "cllz8h5sr00nl01nz3me5bi46",
        owner: "rickard89",
        visibility: "private",
        protected: false,
        draft: false,

        layers: [

            {
                "id": "background",
                "type": "background",
                "metadata": {
                    "mapbox:featureComponent": "satellite",
                    "mapbox:group": "Satellite imagery, land"
                },
                "layout": {},
                "paint": { "background-color": "hsl(222, 56%, 4%)" }
            },

            {
                "id": "satellite",
                "type": "raster",
                "metadata": {
                    "mapbox:featureComponent": "satellite",
                    "mapbox:group": "Satellite imagery, land"
                },
                "source": "mapbox",
                "layout": {},
                "paint": {}
            },









            {
                "minzoom": 10,
                "layout": {
                    "text-size": [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "zoom"
                        ],
                        10,
                        [
                            "match",
                            [
                                "get",
                                "class"
                            ],
                            [
                                "motorway",
                                "trunk",
                                "primary",
                                "secondary",
                                "tertiary"
                            ],
                            11,
                            [
                                "motorway_link",
                                "trunk_link",
                                "primary_link",
                                "secondary_link",
                                "tertiary_link",
                                "street",
                                "street_limited"
                            ],
                            9.9,
                            7.15
                        ],
                        18,
                        [
                            "match",
                            [
                                "get",
                                "class"
                            ],
                            [
                                "motorway",
                                "trunk",
                                "primary",
                                "secondary",
                                "tertiary"
                            ],
                            17.6,
                            [
                                "motorway_link",
                                "trunk_link",
                                "primary_link",
                                "secondary_link",
                                "tertiary_link",
                                "street",
                                "street_limited"
                            ],
                            15.400000000000002,
                            14.3
                        ]
                    ],
                    "text-max-angle": 30,
                    "text-font": [
                        "DIN Pro Medium",
                        "Arial Unicode MS Regular"
                    ],
                    "symbol-placement": "line",
                    "text-padding": 5,
                    "text-rotation-alignment": "map",
                    "text-pitch-alignment": "viewport",
                    "text-field": [
                        "coalesce",
                        [
                            "get",
                            "name_en"
                        ],
                        [
                            "get",
                            "name"
                        ]
                    ],
                    "text-letter-spacing": 0.01
                },
                "filter": [
                    "all",
                    [
                        "has",
                        "name"
                    ],
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        [
                            "match",
                            [
                                "get",
                                "class"
                            ],
                            [
                                "motorway",
                                "trunk",
                                "primary",
                                "secondary",
                                "tertiary"
                            ],
                            true,
                            false
                        ],
                        12,
                        [
                            "match",
                            [
                                "get",
                                "class"
                            ],
                            [
                                "motorway",
                                "trunk",
                                "primary",
                                "secondary",
                                "tertiary",
                                "street",
                                "street_limited"
                            ],
                            true,
                            false
                        ],
                        15,
                        [
                            "match",
                            [
                                "get",
                                "class"
                            ],
                            [
                                "path",
                                "pedestrian",
                                "golf",
                                "ferry",
                                "aerialway"
                            ],
                            false,
                            true
                        ]
                    ],
                    [
                        "step",
                        ["pitch"],
                        true,
                        50,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            2
                        ],
                        60,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            2.5
                        ],
                        70,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            3
                        ]
                    ]
                ],
                "type": "symbol",
                "source": "composite",
                "id": "road-label",
                "paint": {
                    "text-color": "hsl(0, 0%, 100%)",
                    "text-halo-color": [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        [
                            "motorway",
                            "trunk"
                        ],
                        "hsla(0, 5%, 0%, 0.75)",
                        "hsl(0, 5%, 0%)"
                    ],
                    "text-halo-width": 1,
                    "text-halo-blur": 1
                },
                "source-layer": "road"
            },


            {
                "minzoom": 15,
                "layout": {
                    "text-field": [
                        "coalesce",
                        [
                            "get",
                            "name_en"
                        ],
                        [
                            "get",
                            "name"
                        ]
                    ],
                    "icon-image": "intersection",
                    "icon-text-fit": "both",
                    "icon-text-fit-padding": [
                        1,
                        2,
                        1,
                        2
                    ],
                    "text-size": [
                        "interpolate",
                        [
                            "exponential",
                            1.2
                        ],
                        [
                            "zoom"
                        ],
                        15,
                        9,
                        18,
                        12
                    ],
                    "text-font": [
                        "DIN Pro Bold",
                        "Arial Unicode MS Bold"
                    ]
                },
                "filter": [
                    "all",
                    [
                        "==",
                        [
                            "get",
                            "class"
                        ],
                        "intersection"
                    ],
                    [
                        "has",
                        "name"
                    ],
                    [
                        "step",
                        ["pitch"],
                        true,
                        50,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            1
                        ],
                        60,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            1.5
                        ],
                        70,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            2
                        ]
                    ]
                ],
                "type": "symbol",
                "source": "composite",
                "id": "road-intersection",
                "paint": {
                    "text-color": "hsl(230, 36%, 64%)"
                },
                "source-layer": "road"
            },




            {
                "minzoom": 6,
                "layout": {
                    "text-size": 9,
                    "icon-image": [
                        "case",
                        [
                            "has",
                            "shield_beta"
                        ],
                        [
                            "coalesce",
                            [
                                "image",
                                [
                                    "concat",
                                    [
                                        "get",
                                        "shield_beta"
                                    ],
                                    "-",
                                    [
                                        "to-string",
                                        [
                                            "get",
                                            "reflen"
                                        ]
                                    ]
                                ]
                            ],
                            [
                                "image",
                                [
                                    "concat",
                                    [
                                        "get",
                                        "shield"
                                    ],
                                    "-",
                                    [
                                        "to-string",
                                        [
                                            "get",
                                            "reflen"
                                        ]
                                    ]
                                ]
                            ],
                            [
                                "image",
                                [
                                    "concat",
                                    "default-",
                                    [
                                        "to-string",
                                        [
                                            "get",
                                            "reflen"
                                        ]
                                    ]
                                ]
                            ]
                        ],
                        [
                            "concat",
                            [
                                "get",
                                "shield"
                            ],
                            "-",
                            [
                                "to-string",
                                [
                                    "get",
                                    "reflen"
                                ]
                            ]
                        ]
                    ],
                    "icon-rotation-alignment": "viewport",
                    "text-max-angle": 38,
                    "symbol-spacing": [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "zoom"
                        ],
                        11,
                        400,
                        14,
                        600
                    ],
                    "text-font": [
                        "DIN Pro Bold",
                        "Arial Unicode MS Bold"
                    ],
                    "symbol-placement": [
                        "step",
                        [
                            "zoom"
                        ],
                        "point",
                        11,
                        "line"
                    ],
                    "text-rotation-alignment": "viewport",
                    "text-field": [
                        "get",
                        "ref"
                    ],
                    "text-letter-spacing": 0.05
                },
                "filter": [
                    "all",
                    [
                        "case",
                        [
                            "has",
                            "reflen"
                        ],
                        [
                            "<=",
                            [
                                "get",
                                "reflen"
                            ],
                            6
                        ],
                        [
                            "has",
                            "shield_beta"
                        ]
                    ],
                    [
                        "match",
                        [
                            "get",
                            "class"
                        ],
                        [
                            "pedestrian",
                            "service"
                        ],
                        false,
                        true
                    ],
                    [
                        "step",
                        [
                            "zoom"
                        ],
                        [
                            "==",
                            [
                                "geometry-type"
                            ],
                            "Point"
                        ],
                        11,
                        [
                            ">",
                            [
                                "get",
                                "len"
                            ],
                            5000
                        ],
                        12,
                        [
                            ">",
                            [
                                "get",
                                "len"
                            ],
                            2500
                        ],
                        13,
                        [
                            ">",
                            [
                                "get",
                                "len"
                            ],
                            1000
                        ],
                        14,
                        true
                    ],
                    [
                        "step",
                        ["pitch"],
                        true,
                        50,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            2
                        ],
                        60,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            2.5
                        ],
                        70,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            3
                        ]
                    ]
                ],
                "type": "symbol",
                "source": "composite",
                "id": "road-number-shield",
                "paint": {
                    "text-color": [
                        "case",
                        [
                            "has",
                            "shield_beta"
                        ],
                        [
                            "case",
                            [
                                "all",
                                [
                                    "has",
                                    "shield_text_color_beta"
                                ],
                                [
                                    "to-boolean",
                                    [
                                        "coalesce",
                                        [
                                            "image",
                                            [
                                                "concat",
                                                [
                                                    "get",
                                                    "shield_beta"
                                                ],
                                                "-",
                                                [
                                                    "to-string",
                                                    [
                                                        "get",
                                                        "reflen"
                                                    ]
                                                ]
                                            ]
                                        ],
                                        ""
                                    ]
                                ]
                            ],
                            [
                                "match",
                                [
                                    "get",
                                    "shield_text_color_beta"
                                ],
                                "white",
                                "hsl(0, 0%, 100%)",
                                "yellow",
                                "hsl(50, 63%, 70%)",
                                "orange",
                                "hsl(25, 63%, 75%)",
                                "blue",
                                "hsl(230, 36%, 44%)",
                                "red",
                                "hsl(0, 54%, 59%)",
                                "green",
                                "hsl(140, 46%, 37%)",
                                "hsl(230, 11%, 13%)"
                            ],
                            "hsl(230, 11%, 13%)"
                        ],
                        [
                            "match",
                            [
                                "get",
                                "shield_text_color"
                            ],
                            "white",
                            "hsl(0, 0%, 100%)",
                            "yellow",
                            "hsl(50, 63%, 70%)",
                            "orange",
                            "hsl(25, 63%, 75%)",
                            "blue",
                            "hsl(230, 36%, 44%)",
                            "red",
                            "hsl(0, 54%, 59%)",
                            "green",
                            "hsl(140, 46%, 37%)",
                            "hsl(230, 11%, 13%)"
                        ]
                    ]
                },
                "source-layer": "road"
            },




            {
                "minzoom": 14,
                "layout": {
                    "text-field": [
                        "get",
                        "ref"
                    ],
                    "text-size": 9,
                    "icon-image": [
                        "concat",
                        "motorway-exit-",
                        [
                            "to-string",
                            [
                                "get",
                                "reflen"
                            ]
                        ]
                    ],
                    "text-font": [
                        "DIN Pro Bold",
                        "Arial Unicode MS Bold"
                    ]
                },
                "filter": [
                    "all",
                    [
                        "has",
                        "reflen"
                    ],
                    [
                        "<=",
                        [
                            "get",
                            "reflen"
                        ],
                        9
                    ],
                    [
                        "step",
                        ["pitch"],
                        true,
                        50,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            1
                        ],
                        60,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            1.5
                        ],
                        70,
                        [
                            "<",
                            [
                                "distance-from-center"
                            ],
                            2
                        ]
                    ]
                ],
                "type": "symbol",
                "source": "composite",
                "id": "road-exit-shield",
                "paint": {
                    "text-color": "hsl(0, 0%, 100%)",
                    "text-translate": [
                        0,
                        0
                    ]
                },
                "source-layer": "motorway_junction"
            }










        ]
    }

};

export default mapBoxSettings;